/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { BaseDesignFilterDto, BaseDesignListItemDto, CheckUsageDto } from '@gh/builder-shared-data';
import { EMPTY_ID, ID } from '@gh/common-shared-data';

import { omit, uniqueId } from 'lodash';

export type BaseDesignListItem = BaseDesignListItemDto & {
  baseDesignId: ID;
};
export type BaseDesignFilter = BaseDesignFilterDto;
export type BaseDesignCheckUsage = CheckUsageDto;

export const baseDesignUniqueId = () => uniqueId('base-design:');

export const newBaseDesignListItem = () => ({
  id: EMPTY_ID,
  baseDesignId: baseDesignUniqueId(),
  name: '',
  isActive: true,
  masterZoneId: void 0,
  typeId: void 0,
});

export const baseDesignToDto = (baseDesign: BaseDesignListItem) =>
  <BaseDesignListItemDto>omit(baseDesign, ['baseDesignId']);

export const baseDesignFromDto = (baseDesign: BaseDesignListItemDto) => ({
  ...baseDesign,
  baseDesignId: baseDesignUniqueId(),
});
